import script from "./nongye1.vue?vue&type=script&setup=true&lang=js"
export * from "./nongye1.vue?vue&type=script&setup=true&lang=js"

import "./nongye1.vue?vue&type=style&index=0&id=2293b1e4&lang=less&scoped=true"
script.__scopeId = "data-v-2293b1e4"

export default script